import { CountUp } from 'countup.js';

class counterItem extends HTMLElement {
    constructor(){
        super();

        this.number = this.querySelector('.counter-number .value');
    }

    connectedCallback(){
        var numAnim = new CountUp(this.number, this.number.dataset.finish, {
            decimalPlaces: this.number.dataset.decimalplace, // number of decimal places (0)
            duration: 2, // animation duration in seconds (2)
            decimal: '.', // decimal ('.')
          });

        const options_reveal = {
            threshold: 0.5,
          }
          const appearOnScroll = new IntersectionObserver((entries, appearOnScroll) => {
            entries.forEach(entry => {
              if(!entry.isIntersecting) {
                return;
              } else {
                numAnim.start();
                appearOnScroll.unobserve(this.number);
              }
            });
          }, options_reveal);

          appearOnScroll.observe(this.number);
    }
}

customElements.define('counter-item', counterItem);